import React from "react";
import PropTypes from "prop-types";
import PlusCircle from "rialto-icons/PlusCircleGreen";

import styles from "./ExpandButton.css";

const ExpandButton = ({ label, onExpand }) => (
  <button className={styles.root} onClick={onExpand} type="button">
    <PlusCircle />
    <span dangerouslySetInnerHTML={{ __html: label }} />
  </button>
);

ExpandButton.propTypes = {
  label: PropTypes.string.isRequired,
  onExpand: PropTypes.func.isRequired,
};

export default ExpandButton;
